import React from 'react';
import UploadFileContent from '../UploadFilePage/UploadFileContent';
import ResultsContent from '../ResultsPage/ResultsContent';
import './MainContent.css';

// Main container that renders either upload or results view based on current state
function MainContent({ 
  currentView, 
  setCurrentView, 
  currentProject, 
  setCurrentProject, 
  customerNumber, 
  setIsLoading, 
  iFinanceId, 
  priorYearIFinanceId, 
  censusYearData
}) {
  return (
    <main className="main-content">
      {currentView === 'upload' && (
        <UploadFileContent
          setCurrentView={setCurrentView}
          currentView={currentView}
          censusYearData={censusYearData}
          customerNumber={customerNumber}
        />
      )}
      {currentView === 'results' && (
        <ResultsContent 
          setCurrentView={setCurrentView} 
          currentProject={currentProject} 
          currentView={currentView} 
          customerNumber={customerNumber} 
          setIsLoading={setIsLoading}
          iFinanceId={iFinanceId}
          priorYearIFinanceId={priorYearIFinanceId}
          censusYearData={censusYearData}
        />
      )}
    </main>
  );
}

export default MainContent;